import { useNotifications, useScheduleStore } from "@innoclouds/shared";
import { watch } from "vue";
import { useRoute } from "vue-router";

export const useScheduleNotification = () => {
	const route = useRoute();
	const schedule = useScheduleStore();
	const notifications = useNotifications();

	const toggleScheduleToast = () => {
		if (!schedule.isClosed && !schedule.isNight) return notifications.dismiss(schedule.SCHEDULE_TOAST_ID);
		schedule.notify();
	};

	watch([() => schedule.isClosed, () => schedule.isNight, () => route.name], toggleScheduleToast, { immediate: true });
};
